import z from 'zod'
import equipmentDevolutionObject from '~/packages/rural/equipmentDevolution/equipmentDevolutionObject'
import equipmentLoanObject from '~/packages/rural/equipmentLoan/equipmentLoanObject'
import { materialDeliveryObject } from '~/packages/rural/materialDelivery/materialDeliveryObject'
import { materialRequestObject } from '~/packages/rural/materialRequest/materialRequestObject'
import { machineServiceObject } from '~/packages/rural/machineService/machineServiceObject'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'

const protocolTypeValues = [
  'machine_service',
  'equipment_devolution',
  'equipment_loan',
  'withdrawal',
  'veterinary_care',
  'insemination',
  'material_request',
  'material_delivery',
] as const
type ProtocolType = (typeof protocolTypeValues)[number]

export const protocolTypeEnum = {
  machine_service: 'Serviço de máquina',
  equipment_devolution: 'Devolução de equipamento',
  equipment_loan: 'Empréstimo de equipamento',
  withdrawal: 'Retirada',
  veterinary_care: 'Atendimento veterinário',
  insemination: 'Inseminação',
  material_request: 'Pedido de material',
  material_delivery: 'Entrega de material',
} satisfies Record<ProtocolType, string>

export const protocolChildren = z.object({
  machineServiceId: machineServiceObject.shape.id.nullish(),
  equipmentLoanId: equipmentLoanObject.shape.id.nullish(),
  equipmentDevolutionId: equipmentDevolutionObject.shape.id.nullish(),
  veterinaryCareId: z.string().uuid().nullish(),
  inseminationId: z.string().uuid().nullish(),
  materialRequestId: materialRequestObject.shape.id.nullish(),
  materialDeliveryId: materialDeliveryObject.shape.id.nullish(),
})

export const protocolObject = z.object({
  id: z.string().uuid(),
  code: z.number().int().positive(),
  protocolType: z.enum(protocolTypeValues),
  withdrawalId: z.string().uuid().nullish(),
  withdrawalAt: dateOrIsoString().nullish(),
  citizenId: z.string().uuid().nullish(),
  clientId: z.number().int().positive(),
  residenceId: z.string().uuid().nullish(),
  sourceFilter: z.string(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
  ...protocolChildren.shape,
})

type Protocol = z.infer<typeof protocolObject>
type ProtocolSchemaType = Protocol

export const propertyMap = {
  id: sql`id`,
  code: sql`code`,
  protocolType: sql`protocol_type`,
  withdrawalId: sql`withdrawal_id`,
  withdrawalAt: sql`withdrawal_at`,
  citizenId: sql`citizen_id`,
  clientId: sql`client_id`,
  residenceId: sql`residence_id`,
  sourceFilter: sql`source_filter`,
  createdAt: sql`created_at`,
  updatedAt: sql`updated_at`,
  deletedAt: sql`deleted_at`,
  machineServiceId: sql`machine_service_id`,
  equipmentLoanId: sql`equipment_loan_id`,
  equipmentDevolutionId: sql`equipment_devolution_id`,
  veterinaryCareId: sql`veterinary_care_id`,
  inseminationId: sql`insemination_id`,
  materialRequestId: sql`material_request_id`,
  materialDeliveryId: sql`material_delivery_id`,
}

export type { ProtocolType, Protocol, ProtocolSchemaType }
export { protocolTypeValues }
